import MainLayout from './MainLayout';

const PrivateLayout = () => {
  return <MainLayout />;
};

export default PrivateLayout;
